/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ImageObjectApiModel } from './image-object';

export interface UserVehicleApiModel {
  /**
   * Vehicle color
   */
  color?: string;
  /**
   * Fuel cap locked flag
   */
  fuel_tank_cap_locked?: number;
  /**
   * Vehicle ID
   */
  id?: string | null;
  /**
   * Vehicle model
   */
  model?: string | null;
  photo?: ImageObjectApiModel;
  /**
   * Vehicle plate number
   */
  plate_number?: string | null;
  /**
   * Vehicle type
   */
  type?: UserVehicleApiModelTypeEnum;
}
export enum UserVehicleApiModelTypeEnum {
  Car = 'car',
  Suv = 'suv',
  Truck = 'truck',
  Van = 'van',
  Equipment = 'equipment'
}
